/**
 * Formats a byte size for document library table display (e.g. `182 KB`, `2.3 MB`).
 *
 * @returns The result of this operation.
 * @param bytes The bytes value.
 */
export function formatDocumentFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '0 B';
  }

  if (bytes < 1024) {
    return `${Math.round(bytes)} B`;
  }

  const kb = bytes / 1024;
  if (kb < 1024) {
    return Number.isInteger(kb) ? `${kb} KB` : `${kb.toFixed(0)} KB`;
  }

  const mb = kb / 1024;
  if (Number.isInteger(mb)) {
    return `${mb} MB`;
  }

  return `${mb.toFixed(1)} MB`;
}
